import type { VignetteDefinition } from "./types";
import { fishingVignette } from "./fishing.vignette";
import { mermaidVisitVignette } from "./mermaid-visit.vignette";
import { christmasVignette } from "./christmas.vignette";
import { joggingVignette } from "./jogging.vignette";
import { divingVignette } from "./diving.vignette";
import { watchingHorizonVignette } from "./watching-horizon.vignette";
import { halloweenVignette } from "./halloween.vignette";
import { july4thVignette } from "./july4th.vignette";
import { raftBuildingVignette } from "./raft-building.vignette";
import { escapeEndingVignette } from "./escape-ending.vignette";

/**
 * The vignette registry. Phase 3 shipped the plan's three representative
 * vignettes; Phase 5 adds the first real expansion pass (see docs/Castaway
 * Plan.md for what's still open: Sit/Sleep-dependent vignettes like
 * reading/sleeping, the remaining rare events, St Patrick's/New Year's).
 */
export const VIGNETTE_REGISTRY: VignetteDefinition[] = [
  fishingVignette,
  mermaidVisitVignette,
  christmasVignette,
  joggingVignette,
  divingVignette,
  watchingHorizonVignette,
  halloweenVignette,
  july4thVignette,
  raftBuildingVignette,
  escapeEndingVignette,
];

export {
  fishingVignette,
  mermaidVisitVignette,
  christmasVignette,
  joggingVignette,
  divingVignette,
  watchingHorizonVignette,
  halloweenVignette,
  july4thVignette,
  raftBuildingVignette,
  escapeEndingVignette,
};
